import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {translations} from './app.translations';
import {Toast} from 'primeng/toast';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,
    Toast,
    ConfirmDialog,
    TranslateModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('it-IT');
    this.translate.use('it-IT');
  }

  ngOnInit(): void {
  }
}
